import { t } from '@lingui/core/macro';
import { EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AddTaskButton } from './AddTaskButton';
export function EmptyList(props) {
    const { completed = false } = props;
    if (completed) {
        return (<EmptyState actions={<AddTaskButton />} withAvatar size="medium" icon={<Falcon icon="list-check"/>} title={t({
                message: 'Nothing completed!',
                comment: 'Task table no completed tasks - title',
            })} description={t({
                message: 'Get started by creating a new task.',
                comment: 'Task table no completed tasks - description',
            })}/>);
    }
    return (<EmptyState actions={<AddTaskButton />} withAvatar size="medium" icon={<Falcon icon="check"/>} title={t({
            message: 'Well done!',
            comment: 'Task table no uncompleted tasks - title',
        })} description={t({
            message: 'You have completed all your tasks.',
            comment: 'Task table no uncompleted tasks - description',
        })}/>);
}
